// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { purchasedProductsStyles } from "@werner/Overrides/Widgets/Common/PurchasedProducts";
import { css } from "styled-components";

purchasedProductsStyles.purchasedProductCard = {
    descriptionStyles: {
        productDetailLink: {
            typographyProps: {
                ellipsis: true,
                css: css`
                    display: inline-block;
                    white-space: nowrap;
                `,
            },
        },
        tooltip: {
            cssOverrides: {
                tooltipContainer: css`
                    padding: 10px;
                `,
                tooltipBody: css`
                    p {
                        white-space: normal;
                    }
                `,
            },
        },
    },

    productActionsStyles: {
        addToCartContainer: {
            css: css`
                flex-wrap: nowrap;
            `,
        },
    },
};
purchasedProductsStyles.dataTableBody = {
    css: css`
        td > span {
            width: 100%;
        }
        td:last-child {
            padding-right: 0;
        }
    `,
};
